import { CartItem, Product, ProductType } from '@interface/product';
import { ApplicationOrigin } from 'app/stores/globalStore';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

import ROUTES from './routes';

export const ProductRedirect = (
  productToAdd: Product,
  router: AppRouterInstance,
  cart: CartItem[],
  currentOrigin: ApplicationOrigin
) => {
  if (productToAdd.type === ProductType.Esthetic) {
    if (
      currentOrigin === ApplicationOrigin.Gloxbox ||
      currentOrigin === ApplicationOrigin.Landing
    ) {
      router.push(ROUTES.checkout.clinics);
    } else {
      router.push(ROUTES.checkout.payment_type);
    }
  }

  if (productToAdd.type === ProductType.Medical) {
    if (cart && cart.length > 0) {
      router.push(ROUTES.checkout.clinics);
    } else {
      router.push(ROUTES.checkout.type);
    }
  }

  if (productToAdd.type === ProductType.Others) {
    router.push(ROUTES.checkout.clinics);
  }
};
